"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOAST_TRANSITION_DURATION = void 0;
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var keepDom_1 = require("../../utils/keepDom");
var helper_1 = require("../../utils/helper");
var theme_1 = require("../../utils/theme");
exports.TOAST_TRANSITION_DURATION = 200;
var Toast = (function (_super) {
    tslib_1.__extends(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, children = _b.children, content = _b.content, visible = _b.visible, position = _b.position, onClose = _b.onClose, zIndex = _b.zIndex;
            var classes = classNames(prefixCls, className, prefixCls + "-" + position, (_a = {},
                _a[prefixCls + "-hidden"] = !visible,
                _a));
            if (!keepDom_1.decideKeepDom.call(_this, exports.TOAST_TRANSITION_DURATION, visible)) {
                setTimeout(function () {
                    onClose();
                }, 0);
                return null;
            }
            return react_dom_1.default.createPortal(h("div", { className: classes, style: tslib_1.__assign({ zIndex: zIndex }, style) }, children || content), document.body);
        };
        return _this;
    }
    Toast.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Toast;
}(React.Component));
exports.default = Toast;
Toast.defaultProps = {
    prefixCls: 'dui-m-toast',
    visible: false,
    content: '',
    position: 'top',
    onClose: helper_1.emptyFn
};
Toast.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    visible: PropTypes.bool,
    content: PropTypes.node,
    duration: PropTypes.number,
    position: PropTypes.string,
    onClose: PropTypes.func,
    zIndex: PropTypes.number
};
